import { render, staticRenderFns } from "./RatingsWidget.vue?vue&type=template&id=cd37fe5c&scoped=true"
import script from "./RatingsWidget.vue?vue&type=script&lang=js"
export * from "./RatingsWidget.vue?vue&type=script&lang=js"
import style0 from "./RatingsWidget.vue?vue&type=style&index=0&id=cd37fe5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd37fe5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd37fe5c')) {
      api.createRecord('cd37fe5c', component.options)
    } else {
      api.reload('cd37fe5c', component.options)
    }
    module.hot.accept("./RatingsWidget.vue?vue&type=template&id=cd37fe5c&scoped=true", function () {
      api.rerender('cd37fe5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/RatingsWidget.vue"
export default component.exports